export const JUMP_TO_MENU_ID = 'jump-to-equipment-mobile-menu';
